import {
  CHAT_MESSAGE_LIST_NAME,
  CHAT_MODAL_LIST_NAME,
  CHAT_SUBSCRIBERS_LIST_NAME,
  USER_SUBSCRIPTIONS_LIST_NAME,
  VIDEO_CHAT_START_NAME,
  VIDEO_SESSION_NAME,
} from '../redux/state';


/**
 *
 * CODE_TAG[Global-state-shape-aware]
 * @param rootState
 * @return {*}
 */
export function getState(rootState) {
  return rootState.chat;
}

export function getChatMessages(rootState) {
  return getState(rootState)[CHAT_MESSAGE_LIST_NAME];
}

export function getChatModal(rootState) {
  return getState(rootState)[CHAT_MODAL_LIST_NAME];
}

export function getCurrentChatModalId(rootState) {
  return getChatModal(rootState).parentId;
}

export function getChatModalSubscriptionRequest(rootState) {
  return getState(rootState)[CHAT_MODAL_LIST_NAME].updateSubscription;
}

export function getChatSubscribers(rootState) {
  return getState(rootState)[CHAT_SUBSCRIBERS_LIST_NAME];
}

export function getUserSubscriptions(rootState) {
  return getState(rootState)[USER_SUBSCRIPTIONS_LIST_NAME];
}

export function getVideoChatStartModal(rootState) {
  return getState(rootState)[VIDEO_CHAT_START_NAME];
}

export function getVideoChatSession(rootState) {
  return getState(rootState)[VIDEO_SESSION_NAME];
}

export function getVideoChatCreateSession(rootState) {
  return getState(rootState)[VIDEO_SESSION_NAME].createSession;
}

export function getVideoChatStartSession(rootState) {
  return getState(rootState)[VIDEO_SESSION_NAME].startSession;
}

export function getVideoChatJoinSession(rootState) {
  return getState(rootState)[VIDEO_SESSION_NAME].joinSession;
}

export function getVideoChatInviteToSession(rootState) {
  return getState(rootState)[VIDEO_SESSION_NAME].inviteToSession;
}

export function getVideoChatLeaveSession(rootState) {
  return getState(rootState)[VIDEO_SESSION_NAME].leaveSession;
}

export function getVideoChatEndSession(rootState) {
  return getState(rootState)[VIDEO_SESSION_NAME].endSession;
}

export function getVideoChatStartRecording(rootState) {
  return getState(rootState)[VIDEO_SESSION_NAME].startRecording;
}

export function getVideoChatStopRecording(rootState) {
  return getState(rootState)[VIDEO_SESSION_NAME].stopRecording;
}

export function getVideoChatScreenShot(rootState) {
  return getState(rootState)[VIDEO_SESSION_NAME].screenShot;
}

export const videoChatSessionRequestStates = {
  createSession: getVideoChatCreateSession,
  startSession: getVideoChatStartSession,
  joinSession: getVideoChatJoinSession,
  inviteToSession: getVideoChatInviteToSession,
  leaveSession: getVideoChatLeaveSession,
  endSession: getVideoChatEndSession,
  startRecording: getVideoChatStartRecording,
  stopRecording: getVideoChatStopRecording,
  screenShot: getVideoChatScreenShot,
};




// WEBPACK FOOTER //
// ./src/js/comments/reducers/state.js